/* global MEDIA_FETCH_COUNT: true */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-relay';

import EventDualSearchPage from './EventDualSearchPage';
import QueryHandler from '../components/misc/QueryHandler';

import { getCustomerKey } from '../utils/browser-storage';

class EventDualSearchPageQueryRenderer extends Component {
  constructor(props) {
    super(props);

    this.snFromUrl = props.match.params.startnumber;
    this.eventIdFromUrl = props.match.params.id;
    this.searchStartnumberFromUrl = props.match.params.searchstartnumber;
    this.customerKey = getCustomerKey(this.eventIdFromUrl, this.snFromUrl);
  }

  render() {
    const { match } = this.props;

    return (
      <QueryHandler
        query={graphql`
          query EventDualSearchPageQueryRendererQuery(
            $eventId: ID!
            $language: String
            $startnumber: ID!
            $searchStartnumber: ID!
            $count: Int!
            $cursor: String
            $secondFactor: String
            $individualPart: String
          ) {
            viewer {
              ...EventDualSearchPage_viewer
            }
          }
        `}
        variables={{
          eventId: this.eventIdFromUrl,
          language: match.params.language,
          startnumber: this.snFromUrl !== undefined ? this.snFromUrl : '',
          searchStartnumber: this.searchStartnumberFromUrl,
          count: MEDIA_FETCH_COUNT,
          secondFactor: this.customerKey,
          individualPart: '',
        }}
        redirectTo={`/event/${this.eventIdFromUrl}`}
        render={props => {
          return (
            <EventDualSearchPage
              viewer={props.viewer}
              snFromUrl={match.params.startnumber}
              searchStartnumberFromUrl={match.params.searchstartnumber}
              customerKey={this.customerKey}
            />
          );
        }}
      />
    );
  }
}

EventDualSearchPageQueryRenderer.propTypes = {
  match: PropTypes.object,
};

export default EventDualSearchPageQueryRenderer;
